import React from 'react';

import {Icon} from '@blueprintjs/core';

export const SuccessIcon = <Icon icon="tick" intent="success" />;
export const WarningIcon = <Icon icon="warning-sign" intent="warning" />;
export const ErrorIcon = <Icon icon="error" intent="danger" />;
